export const gt = (check: number) => (val: number) => val > check;

export const clamp = (min: number) => (max: number) => (val: number) =>
	Math.min(Math.max(val, min), max);
